import React from "react";
import styles from "./label.module.scss";
import IComponentProps from "../common/component-props";
import clsx from "clsx";

export interface ILabelProps extends Omit<IComponentProps, "disabled"> {
  label: string;
  value: React.ReactNode;
  horizontal?: boolean
}

export function Label(props: ILabelProps) {
  return (
    <div className={clsx(styles.label, props.horizontal && styles.label_horizontal ,props.className)}>
      <span className={styles["label--key"]}>{props.label}</span>
      <span className={styles["label--value"]}>{props.value}</span>
    </div>
  );
}
